import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicationInformationDetails from './AppicationInformationDetails';
import { Attachments } from './Attachments';
import HouseholdIncomeDetails from './HouseholdIncomeDetails';
import PropertyInformationDetails from './PropertyInformationDetails';

export const BDPAApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  return (
    <>
      <ApplicationInformationDetails applicationInformation={applicationData.application} />
      <HouseholdIncomeDetails householdIncome={applicationData?.householdIncome} />
      {applicationData?.userDocumentInfo[0] !== 'hasNothing' && (
        <PropertyInformationDetails propertyInformation={applicationData.propertyInformation} />
      )}

      <Attachments attachments={applicationData.attachments} files={files} />
    </>
  );
};
